import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { StateService } from '@adgate/common/services/state-service';
import { CommonObjectService } from '@adgate/common/services/common-object-service';
import { DialogService } from '@adgate/common/services/dialog-service';
import { RESTApplicationResponse } from '@adgate/common/types/rest-application-response.type';
import { SpecError } from '@adgate/common/types/spec-error.type';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface SpecCheckReportData 
{
  objectType: number;
  objectId: number;
  title: string;
  allowUpload: boolean;
  specsUrl: string;
}

@Component({
  selector: 'app-spec-check-report-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule,
    ClipboardModule
  ],
  templateUrl: './spec-check-report-dialog-component.html',
  styleUrl: './spec-check-report-dialog-component.scss',
})
export class SpecCheckReportDialogComponent implements OnInit
{
  public dialogData: SpecCheckReportData = inject<SpecCheckReportData>(MAT_DIALOG_DATA);
  public stateService: StateService = inject(StateService);
  public commonObjectService: CommonObjectService = inject(CommonObjectService);
  public dialogService: DialogService = inject(DialogService);
  private dialogHandle = inject(MatDialogRef<SpecCheckReportDialogComponent>);
  private cdr: ChangeDetectorRef = inject( ChangeDetectorRef );
  private _snackBar: MatSnackBar = inject(MatSnackBar);

  specErrors: SpecError[] = [];

  constructor() 
  {

  }

  ngOnInit(): void 
  {
    this.dialogService.showProgress();
    this.commonObjectService.getObjectSpecErrorReport( this.dialogData.objectType, this.dialogData.objectId ).subscribe({
      next: (r:RESTApplicationResponse) => {
        this.specErrors = r.data;
        this.dialogService.hideProgress();
        this.cdr.detectChanges();
      },
      error: (err:Error) => {
        this.dialogService.openErrorDialog(err.message);
      }
    });
  }

  get hasFailed(): boolean 
  {
    return this.specErrors.some(r => !r.passed);
  }

  onClose(): void 
  {
    this.dialogHandle.close(null);
  }

  onViewSpecsGuide(): void 
  {
    window.open(this.dialogData.specsUrl, '_blank');
  }

  onUploadNewVersion(): void 
  {
    this.dialogHandle.close('upload');
  }

  onCopyToClipboard(data: string)
  {
    this._snackBar.open( `${data} copied to clipboard`, '',{duration: 2000});
  }
}